import React, { useState, useRef } from 'react';
import Post from '../Post';
import axios from 'axios';
import Editor from './Editor/Editor';
import Sidebar from './Sidebar';
import './styles.css';
import { useNavigate } from 'react-router-dom';

const NewPostPage = () => {
  const [post, setPost] = useState(new Post());
  const imagesRef = useRef([]); // Store image files and placeholders
  const [content, setContent] = useState('');
  const navigate = useNavigate();

  const handleTitleChange = (e) => {
    setPost({ ...post, title: e.target.value });
  };

  const handlePublish = async () => {
    const publishDate = new Date();
    const updatedPost = { ...post, publishedDate: publishDate, isPublished: true };

    // Grab the raw HTML from Quill
    const editor = document.querySelector('.ql-editor');
    let updatedContent = editor.innerHTML;

    // Upload any images that have placeholders
    const imageUploadPromises = imagesRef.current.map(async (imageObj) => {
      const formData = new FormData();
      formData.append('image', imageObj.file);

      let apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
      const response = await axios.post(`${apiBaseUrl}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const uploadedUrl = response.data.imageUrl;

      // Replace the placeholder in the running 'updatedContent'
      updatedContent = updatedContent.replace(imageObj.placeholder, uploadedUrl);
    });

    // Wait for all image uploads & replacements to finish
    await Promise.all(imageUploadPromises);

    // Now assign the final HTML content
    updatedPost.content = updatedContent;

    // Make the POST request to the server
    try {
      const token = localStorage.getItem('token');
      let apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
      await axios.post(`${apiBaseUrl}/posts`, updatedPost, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
      });

      alert('Post created successfully!');
      navigate('/');

      // Reset local state
      setPost(new Post());
      setContent('');
      imagesRef.current = [];

    } catch (error) {
      console.error('Error publishing post:', error);
    }
  };

  return (
    <div className="Container">
      <div className="EditorSection">
        <input
          className="TitleInput"
          type="text"
          placeholder="Title"
          value={post.title}
          onChange={handleTitleChange}
        />
        <Editor content={content} setContent={setContent} imagesRef={imagesRef} />
      </div>
      <Sidebar post={post} setPost={setPost} handlePublish={handlePublish} />
    </div>
  );
};

export default NewPostPage;
